export default function Copyright() {
  return (
    <p className="text-sm m-0 text-greyscale-placeholder text-center">
      © {new Date().getFullYear()} WINELIVERY DUE S.R.L., all rights reserved. • p.i.:
      14834210966 • sede legale:  Via Maurizio Gonzaga 5, 20123 Milano (MI) • capitale
      sociale: 10.000,00€ • numero rea: MI - 2810335
    </p>
  );
}
